module.exports = __webpack_public_path__ + "static/media/standard-quadruplo.41e6e19d.jpg";